import ContentArea from "@/components/ContentArea";
import { ExternalChangeProvider } from "@/components/ContentArea/external-update-context";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { runInAction } from "mobx";
import { memo } from "react";
import { IMessageStore } from "./message-store";
import RoleSelector from "./RoleSelector";

const FullscreenDialog = ({
  isOpen,
  onOpenChange,
  message,
  readonly = false,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  message: IMessageStore;
  readonly?: boolean;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="fixed inset-0 flex h-screen w-screen max-w-none translate-x-0 translate-y-0 flex-col rounded-none border-0 p-0 shadow-none"
        shouldShowCloseButton={false}
      >
        <div className="flex h-14 items-center justify-between gap-x-2 border-b bg-background px-4 py-3">
          <RoleSelector
            selected={message.role}
            readonly={readonly}
            onSelect={(role) => runInAction(() => message.setRole(role))}
          />

          <Button
            variant="ghost"
            size="icon"
            onClick={() => onOpenChange(false)}
            className="h-8 w-8 rounded-full hover:bg-muted"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close fullscreen</span>
          </Button>
        </div>

        <div className="flex-1 overflow-hidden bg-background">
          <div className="h-full px-4 pb-4">
            <ExternalChangeProvider>
              <ContentArea
                onChange={(e) =>
                  !readonly && message.setMessage(e.target.value)
                }
                value={message.content}
                className="h-full rounded border text-sm"
                containerClassName="h-full"
                readOnly={readonly}
                placeholder={readonly ? "" : "Type / to use a widget..."}
              />
            </ExternalChangeProvider>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(FullscreenDialog);
